<template>
  <div class="cell-wrapper">
    <div class="cell" :class="{
      'top-edge': hasTopEdge,
      'bottom-edge': hasBottomEdge,
      'left-edge': hasLeftEdge,
      'right-edge': hasRightEdge,
      'is-grid': isGrid,
      'has-block': hasBlock,
      'hover': hover
    }" :style="{'background-color': color}"
         :content="content"
    >
      <div class="caption" :class="{'date-caption': content.length > 1}">
        <p v-if="hover || content.length > 1">{{ content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalendarCell',
  props: {
    col: Number,
    row: Number,
    hasBlock: Boolean,
    isGrid: Boolean,
    hasTopEdge: Boolean,
    hasBottomEdge: Boolean,
    hasLeftEdge: Boolean,
    hasRightEdge: Boolean,
    content: String,
    color: String,
    hover: Boolean
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.cell-wrapper, .cell, .cell * {
  --gap: 2px;
}

.cell-wrapper {
  width: 4rem;
  height: 4rem;
  position: relative;
  margin: var(--gap);
}

.cell {
  width: 4rem;
  height: 4rem;
  top: 0;
  left: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  /*background-color: #eee;*/
  position: absolute;
  z-index: 10;
  user-select: none;
  transform-style: preserve-3d;
  -webkit-transform-style: preserve-3d;
  transition: all ease-in-out .1s;
}

.cell:active {
  filter: brightness(95%);
}

.top-edge.left-edge {
  border-top-left-radius: 20%;
}

.bottom-edge.left-edge {
  border-bottom-left-radius: 20%;
}

.top-edge.right-edge {
  border-top-right-radius: 20%;
}

.bottom-edge.right-edge {
  border-bottom-right-radius: 20%;
}

/* connections */

.top-edge:after, .top-edge:before,
.left-edge:after, .left-edge:before,
.right-edge:after, .right-edge:before,
.bottom-edge:after, .bottom-edge:before {
  content: '';
  position: absolute;
  background-color: inherit;
  top: 50%;
  left: 50%;
  right: 50%;
  bottom: 50%;
  z-index: -1;
}

.cell:not(.left-edge):after {
  top: 0;
  bottom: 0;
  left: calc(var(--gap) * -2);
}

.cell:not(.top-edge):before {
  left: 0;
  right: 0;
  top: calc(var(--gap) * -2);
}

.cell:not(.is-grid) {
  background-color: transparent;
}

/* */

.cell.hover {
  transform: translateZ(10px);
  -webkit-transform: translateZ(10px);
}

.caption {
  font-size: 2rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  transition: all .3s ease-in-out;
}

.caption:not(.date-caption) {
  color: transparent;
}

.date-caption, .hover > .caption {
  color: white;
}

</style>
